var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 100,
    viewBox: "0 0 96 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-checked"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M80.3048 16.9213V16.9213C62.4762 -1.40018 33.5239 -1.40018 15.6953 16.9213C-2.20947 35.1647 -2.20947 64.7909 15.6953 83.0343C24.6096 92.1561 36.2667 96.7559 48.0001 96.7559C53.6382 96.7559 59.3524 95.6644 64.6858 93.5594C70.4001 91.2985 75.7334 87.7901 80.3048 83.1123C87.6191 75.6278 91.962 66.1942 93.2572 56.4488C95.162 42.4153 90.8953 27.6802 80.3048 16.9213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 48,
    cy: 49.978,
    rx: 27.4286,
    ry: 28.0669,
    fill: "#5B4DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M48.0001 61.6725C47.3905 61.6725 46.781 61.4386 46.4001 60.9708L34.9715 49.2763C34.0572 48.3407 34.0572 46.8594 34.9715 46.0018C35.8858 45.0663 37.3334 45.0663 38.1715 46.0018L47.8477 55.9032L69.1048 30.4871C69.9429 29.4735 71.3905 29.3956 72.3048 30.2532C73.2953 31.1108 73.3715 32.5921 72.5334 33.5276L49.6762 60.8149C49.2953 61.2827 48.6858 61.5945 48.0001 61.5945C48.0762 61.6725 48.0001 61.6725 48.0001 61.6725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 49.9779C0 77.0312 21.5619 99.0949 48 99.0949C74.4381 99.0949 96 77.0312 96 49.9779C96 22.9245 74.4381 0.86084 48 0.86084C21.5619 0.86084 0 22.9245 0 49.9779ZM4.57143 49.9779C4.57143 25.4973 24.0762 5.53865 48 5.53865C71.9238 5.53865 91.4286 25.4973 91.4286 49.9779C91.4286 74.4584 71.9238 94.4171 48 94.4171C24.0762 94.4171 4.57143 74.4584 4.57143 49.9779Z",
    fill: "#EAF3FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.3dffd071681ced39ff6cd23820ff9d42.svg";
export { ForwardRef as ReactComponent };